/**
 * TV World E-Wholesale — Recent Sales Popup
 * File: assets/sales-popup.js
 * Version: 1.0.0
 *
 * No monthly fee. No app. Drop-in replacement for paid social proof apps.
 * Works with TV-WORLD v1.0.5 + Shopify View Transitions.
 */

(function () {
  'use strict';

  // ─── City pool (US markets) ────────────────────────────────────────────────
  var CITIES = [
    'Los Angeles, CA', 'San Francisco, CA', 'San Jose, CA', 'Fresno, CA',
    'Sacramento, CA', 'Modesto, CA', 'Stockton, CA', 'Bakersfield, CA',
    'Oakland, CA', 'Riverside, CA', 'Anaheim, CA', 'Long Beach, CA',
    'San Diego, CA', 'Santa Ana, CA', 'Chula Vista, CA', 'Fontana, CA',
    'Houston, TX', 'Dallas, TX', 'San Antonio, TX', 'Austin, TX',
    'El Paso, TX', 'Fort Worth, TX', 'Arlington, TX',
    'Miami, FL', 'Orlando, FL', 'Jacksonville, FL', 'Tampa, FL',
    'Chicago, IL', 'Phoenix, AZ', 'Tucson, AZ', 'Las Vegas, NV',
    'New York, NY', 'Brooklyn, NY', 'Queens, NY', 'Bronx, NY',
    'Seattle, WA', 'Denver, CO', 'Atlanta, GA', 'Portland, OR',
    'Albuquerque, NM', 'Charlotte, NC', 'Columbus, OH', 'Detroit, MI',
    'Memphis, TN', 'Louisville, KY', 'Baltimore, MD', 'Boston, MA',
    'Washington, DC', 'Nashville, TN', 'Oklahoma City, OK', 'Reno, NV'
  ];

  // ─── Injected CSS ──────────────────────────────────────────────────────────
  var CSS = [
    '#tvw-sp-root {',
    '  position: fixed;',
    '  bottom: 24px;',
    '  left: 20px;',
    '  z-index: 99999;',
    '  width: 310px;',
    '  pointer-events: none;',
    '  opacity: 0;',
    '  transform: translateY(22px);',
    '  transition: opacity 0.42s ease, transform 0.42s cubic-bezier(0.34,1.4,0.64,1);',
    '}',
    '#tvw-sp-root.tvw-sp-show {',
    '  opacity: 1;',
    '  transform: translateY(0);',
    '  pointer-events: all;',
    '}',
    '#tvw-sp-card {',
    '  background: #141414;',
    '  border: 1px solid rgba(255,255,255,0.11);',
    '  border-radius: 12px;',
    '  box-shadow: 0 12px 40px rgba(0,0,0,0.55);',
    '  overflow: hidden;',
    '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;',
    '  position: relative;',
    '}',
    '#tvw-sp-link {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 12px;',
    '  padding: 13px 34px 13px 13px;',
    '  text-decoration: none;',
    '  color: inherit;',
    '}',
    '#tvw-sp-link:hover { background: rgba(255,255,255,0.04); }',
    '#tvw-sp-thumb {',
    '  flex-shrink: 0;',
    '  width: 56px;',
    '  height: 56px;',
    '  border-radius: 8px;',
    '  overflow: hidden;',
    '  background: #2a2a2a;',
    '}',
    '#tvw-sp-thumb img {',
    '  width: 56px;',
    '  height: 56px;',
    '  object-fit: cover;',
    '  display: block;',
    '}',
    '#tvw-sp-body {',
    '  display: flex;',
    '  flex-direction: column;',
    '  gap: 3px;',
    '  min-width: 0;',
    '}',
    '#tvw-sp-loc {',
    '  font-size: 11px;',
    '  color: #8e8e93;',
    '  white-space: nowrap;',
    '  overflow: hidden;',
    '  text-overflow: ellipsis;',
    '}',
    '#tvw-sp-name {',
    '  font-size: 13px;',
    '  font-weight: 600;',
    '  color: #f2f2f7;',
    '  line-height: 1.3;',
    '  display: -webkit-box;',
    '  -webkit-line-clamp: 2;',
    '  -webkit-box-orient: vertical;',
    '  overflow: hidden;',
    '}',
    '#tvw-sp-time {',
    '  font-size: 11px;',
    '  color: #f97316;',
    '  font-weight: 500;',
    '}',
    '#tvw-sp-close {',
    '  position: absolute;',
    '  top: 8px;',
    '  right: 8px;',
    '  width: 20px;',
    '  height: 20px;',
    '  background: rgba(255,255,255,0.09);',
    '  border: none;',
    '  border-radius: 50%;',
    '  color: #8e8e93;',
    '  font-size: 10px;',
    '  cursor: pointer;',
    '  padding: 0;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  line-height: 1;',
    '}',
    '#tvw-sp-close:hover { background: rgba(255,255,255,0.18); color: #fff; }',
    '#tvw-sp-bar { height: 3px; background: rgba(255,255,255,0.07); }',
    '#tvw-sp-bar-fill {',
    '  height: 100%;',
    '  background: linear-gradient(90deg, #ea580c, #f97316);',
    '  width: 100%;',
    '  transform-origin: left;',
    '}',
    /* Mobile */
    '@media (max-width: 380px) {',
    '  #tvw-sp-root { left:10px; right:10px; width:auto; bottom:14px; }',
    '}'
  ].join('\n');

  // ─── Popup object ──────────────────────────────────────────────────────────
  var Popup = {
    el: null,
    config: null,
    _hideT: null,
    _nextT: null,
    _showing: false,
    _usedIndices: [],

    /**
     * Call this from your snippet to boot the popup.
     * @param {Object} cfg
     * @param {Array}  cfg.products           - [{title, url, image}]
     * @param {Number} cfg.initialDelay       - ms before first popup      (default 5000)
     * @param {Number} cfg.displayDuration    - ms each popup stays visible (default 5000)
     * @param {Number} cfg.repeatIntervalMin  - min ms between popups       (default 7000)
     * @param {Number} cfg.repeatIntervalMax  - max ms between popups       (default 10000)
     */
    init: function (cfg) {
      if (!cfg || !Array.isArray(cfg.products) || !cfg.products.length) return;
      this.config = {
        products: cfg.products,
        initialDelay: cfg.initialDelay || 5000,
        displayDuration: cfg.displayDuration || 5000,
        repeatIntervalMin: cfg.repeatIntervalMin || 7000,
        repeatIntervalMax: cfg.repeatIntervalMax || 10000
      };
      this._injectStyles();
      this._build();
      this._schedule(this.config.initialDelay);
    },

    _injectStyles: function () {
      if (document.getElementById('tvw-sp-css')) return;
      var s = document.createElement('style');
      s.id = 'tvw-sp-css';
      s.textContent = CSS;
      document.head.appendChild(s);
    },

    _build: function () {
      if (document.getElementById('tvw-sp-root')) {
        this.el = document.getElementById('tvw-sp-root');
        return;
      }
      var root = document.createElement('div');
      root.id = 'tvw-sp-root';
      root.setAttribute('role', 'status');
      root.setAttribute('aria-live', 'polite');
      root.innerHTML =
        '<div id="tvw-sp-card">' +
          '<button id="tvw-sp-close" onclick="window.TVWSalesPopup.dismiss()" aria-label="Dismiss notification">\u2715</button>' +
          '<a id="tvw-sp-link" href="#" target="_self">' +
            '<div id="tvw-sp-thumb"><img id="tvw-sp-img" src="" alt="" width="56" height="56"></div>' +
            '<div id="tvw-sp-body">' +
              '<span id="tvw-sp-loc"></span>' +
              '<span id="tvw-sp-name"></span>' +
              '<span id="tvw-sp-time"></span>' +
            '</div>' +
          '</a>' +
          '<div id="tvw-sp-bar"><div id="tvw-sp-bar-fill"></div></div>' +
        '</div>';
      document.body.appendChild(root);
      this.el = root;
    },

    _pick: function () {
      var products = this.config.products;
      // Cycle without repeating until all shown
      if (this._usedIndices.length >= products.length) this._usedIndices = [];
      var available = products
        .map(function (_, i) { return i; })
        .filter(function (i) { return this._usedIndices.indexOf(i) === -1; }, this);
      var idx = available[Math.floor(Math.random() * available.length)];
      this._usedIndices.push(idx);
      return products[idx];
    },

    show: function () {
      if (this._showing) return;
      var product = this._pick();
      var city    = CITIES[Math.floor(Math.random() * CITIES.length)];
      var mins    = Math.floor(Math.random() * 52) + 4; // 4–55 min

      document.getElementById('tvw-sp-img').src     = product.image;
      document.getElementById('tvw-sp-img').alt     = product.title;
      document.getElementById('tvw-sp-link').href   = product.url;
      document.getElementById('tvw-sp-loc').textContent  = 'Someone in ' + city;
      document.getElementById('tvw-sp-name').textContent = product.title;
      document.getElementById('tvw-sp-time').textContent = 'ordered ' + mins + ' min. ago';

      this.el.classList.add('tvw-sp-show');
      this._showing = true;

      // Animate progress bar
      var fill = document.getElementById('tvw-sp-bar-fill');
      var dur  = this.config.displayDuration;
      fill.style.transition = 'none';
      fill.style.width = '100%';
      setTimeout(function () {
        fill.style.transition = 'width ' + dur + 'ms linear';
        fill.style.width = '0%';
      }, 60);

      // Auto-hide
      clearTimeout(this._hideT);
      var self = this;
      this._hideT = setTimeout(function () { self.dismiss(); }, dur);
    },

    dismiss: function () {
      if (!this.el) return;
      this.el.classList.remove('tvw-sp-show');
      this._showing = false;
      clearTimeout(this._hideT);
      // Randomize the gap so it feels organic, not like a timer
      var min = this.config.repeatIntervalMin;
      var max = this.config.repeatIntervalMax;
      this._schedule(Math.floor(Math.random() * (max - min + 1)) + min);
    },

    _schedule: function (delay) {
      clearTimeout(this._nextT);
      var self = this;
      this._nextT = setTimeout(function () {
        if (!self._showing) self.show();
      }, delay);
    }
  };

  // Expose globally so Liquid inline onclick + snippet init can reach it
  window.TVWSalesPopup = Popup;

})();
